
import Vue from 'vue'

Vue.filter('transformTime', (val, type) => {
    if(!type) {
        let arr = val.split(' ')[0].split('-')
        return arr[0] + ' 年 ' + arr[1] + ' 月 ' + arr[2] + ' 日 '
    } else {
        return val.split(' ')[0].split('-').join(type)
    }
    
})


// WEBPACK FOOTER //
// ./src/filters/index.js